//** Import Components */
import React, { useState } from "react";
import {
  Table,
  Tooltip,
  Empty,
  Space,
  Grid,
  Pagination,
  Collapse,
  Button,
} from "antd";

import moment from "moment";
import { TABLE_DATE_FORMAT } from "../common/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faReceipt } from "@fortawesome/free-solid-svg-icons"; // Importa el ícono de recibo

export const useManageBillingHistory = () => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { Panel } = Collapse;

  const columns = [
    {
      title: "Payment ID",
      key: "payment_id",
      render: (text) => text.id,
    },
    {
      title: "Date Created",
      key: "created",
      render: (text) => (
        <>{moment.unix(text.created).format(TABLE_DATE_FORMAT)}</>
      ),
    },
    {
      title: "Receipt URL",
      key: "action",
      render: (text) => (
        <Space size="middle">
          <button
            type="primary"
            onClick={() => window.open(text.receipt_url, "_blank")}
          >
            <Tooltip title="Receipt">
              <FontAwesomeIcon icon={faReceipt} />
            </Tooltip>
          </button>
        </Space>
      ),
    },
  ];

  const CardListComponent = ({ listItems }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 10;
    const start = (currentPage - 1) * pageSize;
    const currentItems = listItems.slice(start, start + pageSize);

    return (
      <>
        <Collapse accordion>
          {currentItems.map((item) => (
            <Panel
              key={item.id}
              header={
                <div>
                  <strong>{item.id}</strong> -{" "}
                  {moment.unix(item.created).format(TABLE_DATE_FORMAT)}
                </div>
              }
            >
              <p>
                <strong>Payment ID:</strong> {item.id}
              </p>
              <p>
                <strong>Date Created:</strong>{" "}
                {moment.unix(item.created).format(TABLE_DATE_FORMAT)}
              </p>
              <Button
                type="primary"
                onClick={() => window.open(item.receipt_url, "_blank")}
              >
                <Tooltip title="Receipt">
                  <FontAwesomeIcon icon={faReceipt} />
                </Tooltip>
              </Button>
            </Panel>
          ))}
        </Collapse>

        <div style={{ marginTop: 16, textAlign: "center" }}>
          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={listItems.length}
            onChange={(page) => setCurrentPage(page)}
            size="small"
          />
        </div>
      </>
    );
  };

  const ListComponent = ({ emptyMessage, listItems }) => {
    if (listItems.length === 0) {
      return (
        <Empty
          image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
          imageStyle={{ height: 60 }}
          description={<span>{emptyMessage}</span>}
        />
      );
    }

    return screens.md ? (
      <Table columns={columns} dataSource={listItems} />
    ) : (
      <CardListComponent listItems={listItems} />
    );
  };

  return [ListComponent];
};
